import { config } from '../../config';

class ChatService {

    async openChat(toExtension = null) {
        localStorage.setItem('requestedExtension', toExtension ? toExtension : 'NULL');
        let url = `${config.romeUi}/chat.html`;
        let chatWindow = window.open(url, '_blank', 'width=500,height=700,toolbar=0,menubar=0,location=0,popup=yes');
    }
}

const chatService = new ChatService();

export { chatService }



// WEBPACK FOOTER //
// ./src/framework/utils/chat-service.js